
export default {
  name: "HappyKidsCommentCard",
  props: {
      data: {
          type: Object,
          default: () => {},
      },
      trimText: {
        type: Boolean,
        default: false,
      }
  },
  data() {
    return {
      // locale: this.$i18n.locale,
    }
  },
  computed: {
    handleMessage() {
      const message = this.data?.RichText;
      const maxLength = 150;

      if ( !message ) return;

      const plainTextLength = message.replace(/<[^>]*>/g, '').length;
      if (plainTextLength > maxLength) {
        return this.trimHtml(message, maxLength);
      }
      return message;
    }
  },
  methods: {
    trimHtml(html, maxLength) {
      let charCount = 0;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const walker = document.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false);

      while (walker.nextNode()) {
        const node = walker.currentNode;
        const remainingChars = maxLength - charCount;
        if (node.nodeValue.length > remainingChars) {
          node.nodeValue = node.nodeValue.slice(0, remainingChars) + '...';
          break;
        }
        charCount += node.nodeValue.length;
      }

      // Remove any remaining nodes after the trim point
      while (walker.nextNode()) {
        const node = walker.currentNode;
        node.nodeValue = '';
      }

      return doc.body.innerHTML;
    }
  },
}
